<header class="header">
    <div class="logo-red" routerLink="/login"></div>
</header>

<form class="lang-form" [formGroup]="form">
  <div class="lang-box">
    <p-selectButton name="language" 
      formControlName="language" 
      [options]="languageOptions" 
      optionLabel="name"
      optionDisabled="disabled" 
      (click)="fixLanguage()">
      <ng-template let-item pTemplate>
        <div [class]="item.class"></div>
      </ng-template>
    </p-selectButton>
  </div>
</form>


<div class="login-wrapper" >
    <div class="login-card">
        
        <div class="overlay" *ngIf="isLoading">
            <p-progressSpinner styleClass="large-spinner"></p-progressSpinner>
        </div>
        <div class="isDivCreate" [style.display]="isDivCreate">
        <div class="title">
            <h2>{{ 'user.activateAccount.header'| transloco }}</h2>
            <p>{{ 'user.activateAccount.body1' | transloco }}<b>{{ email }}</b>
                {{ 'user.activateAccount.body2' | transloco }}</p>
            <p>{{ 'user.activateAccount.body3' | transloco }}</p>
        </div>
        <form class="sendCode" [formGroup]="form" >
            <!-- <p-inputOtp formControlName="code" [integerOnly]="true" [length]="6" /> -->
            <p-messages id="messages" [(value)]="messagesCode" [enableService]="false" [style]="{'font-size':'15px'}" />
            <p>{{ 'user.activateAccount.linkMsg' | transloco }}</p>
            <div class="row">
                {{ 'user.forgotPassword.resend' | transloco }}
                <a [routerLink]="[]" (click)="sendEmailAgain()" [class.disabled]="isButtonDisabled"
                    [attr.aria-disabled]="isButtonDisabled ? 'true' : null"
                    [style.pointer-events]="isButtonDisabled ? 'none' : 'auto'">
                    {{ 'user.forgotPassword.resend2' | transloco }}
                </a>
                <span *ngIf="isButtonDisabled">({{ countdown }}s)</span>
            </div>
        </form>
        <!-- <p-button type="submit" 
            severity="danger" 
            [raised]="true" (click)="onSubmit()"
            label="{{ 'user.activateAccount.btnActive' | transloco }}">
        </p-button> -->
        </div>

        <div class="isDivActivate" [style.display]="isDivActivated">
            <div class="container">
                <div class="title">
                    <h1>{{ (alreadyConfirmed ? 'user.activateAccount.alreadyActivated' : 'user.activateAccount.title3') | transloco }}</h1>
                </div>
                <p>{{ 'user.activateAccount.body4' | transloco }}
                    <a id="redirect" [routerLink]="[]" (click)="redirect()">
                        {{ 'user.activateAccount.body6' | transloco }}
                    </a>
                </p>
            </div>
        </div>

        <div class="isDivExpired" [style.display]="isDivExpired">
            <div class="container">
                <div class="title">
                    <h1>{{ 'user.activateAccount.title4' | transloco }}</h1>
                </div>
                <p>{{ 'user.activateAccount.body5' | transloco }}
                    <a id="expired" [routerLink]="[]" (click)="expired()">
                        {{ 'user.activateAccount.body6' | transloco }}
                    </a>
                </p>
            </div>
        </div>

</div>
</div>

<footer class="footer" [ngStyle]="{'background-image': footerBackground}">
  <div class="footer-content">
    <!-- <div class="footer-top">
      <select class="language-select">
        <option value="pt-BR">🇧🇷 Brasil - Português</option>
      </select>
    </div> -->
    <div class="footer-logo">
      <img src="assets/img/logo-FTCloud-white.svg" alt="FT Pilot" />
    </div>
    <div class="footer-bottom">
      <p>{{'footer.rightsReserved' | transloco }}</p>
    </div>
  </div>
</footer>